import React, { useContext, useRef } from "react";
import Footer from "./Footer";
import Docs from "./Docs/Docs";
import Context from "../../Context";
import {
  Switch,
  Route,
  useRouteMatch,
  useLocation,
  Link,
} from "react-router-dom";
import Support from "../Misc/Support";
import Subheader from "./Subheader";
import Aside from "./Aside";
import Admin from "./Admin/Admin";
import HeaderMobile from "./Header/HeaderMobile";
import Header from "./Header/Header";
import UserMenu from "./UserMenu";
import Pending from "../Misc/Pending";
import BigError from "../Misc/BigError";
import ConfirmEmail from "../Misc/ConfirmEmail";
import Staff from "../Essence/Staff/Staff";
import Manual from "./Manual/Manual";
import ManualChanged from "./Manual/ManualChanged";
import ScrollTop from "../Misc/ScrollTop";
import Reference from "./Reference/Reference";
import Tasks from "./Tasks/Tasks";
import Notice from "./Notice/Notice";
import Library from "../Essence/Library/Library";
import Workdoc from "./Workdoc/Workdoc";
import Chat from "./Chat/Chat";
import Assistant from "./Assistant/Assistant";
import Search from "./Search/Search";
import Model from "./Model/Model";
import Element from "./Element/Element";
import Spec from "./Spec/Spec";
import Order from "./Order/Order";
import Product from "./Product/Product";
import Delivery from "./Delivery/Delivery";
import Request from "./Request/Request";
import Scheme from "../Essence/Scheme/Scheme";
import Index from "./Index/Index";
import Maint from "./Maint/Maint";
import Undertake from "./Undertake/Undertake";
import Fda from "./Fda/Fda";
import Repair from "./Repair/Repair";
import Tracker from "./Tracker/Tracker";
import Bunker from "./Bunker/Bunker";
import BunkerOrder from "./BunkerOrder/BunkerOrder";
import Certificate from "./Certificate/Certificate";
import Report from "./Report/Report";
import ActMaintenance from "./ActMaintenance/ActMaintenance";
import Profile from "./Profile/Profile";
import BunkerUpdate from "./BunkerUpdate/BunkerUpdate";
import Crew from "./Crew/Crew";
import Ship from "./Ship/Ship";
import Timesheet from "./Timesheet/Timesheet";

function Layout() {
  const cx = useContext(Context);
  cx.breadCrumbsFlush();
  cx.breadCrumbsAdd("Главная", "/");

  const subheaderPlaceholderRef = useRef(null);

  let fullArea = false;
  const fullAreaPages = [
    "/workdoc",
    "/model",
    "/element",
    "/chat",
    "/assistant",
    "/spec",
    "/product",
    "/maint",
    "/tracker",
    "/report",
    "/admin/workflow",
  ];
  let location = useLocation();
  fullAreaPages.forEach((page) => {
    if (location.pathname.includes(page)) {
      fullArea = true;
    }
  });

  let inAdmin = useRouteMatch("/admin");
  let inConfirm = useRouteMatch("/confirm/email/:code/");
  let inProfile = useRouteMatch("/profile");

  function makeContainerClasses() {
    let classes = [
      "mh100",
      "header-fixed",
      "header-mobile-fixed",
      "subheader-enabled",
      "subheader-fixed",
      "aside-enabled",
      "aside-fixed",
    ];
    if (!cx.asideIsExpanded) {
      if (cx.asideIsHovered) {
        classes.push("aside-minimize-hover");
      } else {
        classes.push("aside-minimize");
      }
    }
    return classes.join(" ");
  }

  let showPending = false;
  if (cx.user.pending) showPending = true;

  let passwordchange = false;
  if (cx.user.info) {
    passwordchange = cx.user.info.profile.passwordchange ? true : false;
  }

  if (showPending) {
    return <Pending />;
  } else {
    if (inConfirm) {
      return (
        <ConfirmEmail code={inConfirm.params ? inConfirm.params.code : false} />
      );
    }
    if (cx.user.isAuthorized) {
      if (cx.user.isGuest) {
        return (
          <>
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              <div className="card card-custom wave wave-animate-fast wave-success w-50">
                <div className="card-body">
                  <div className="d-flex align-items-center p-5">
                    <div className="mr-6">
                      <span className="flaticon2-shield icon-3x text-success"></span>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3">
                        Добро пожаловать!
                      </div>
                      <div className="text-dark-75">
                        Ваша учетная запись еще не была одобрена администратором
                        системы. Как только администратор одобрит вашу учетную
                        запись вы получите соответствующее уведомление
                        <div>
                          <button
                            onClick={cx.user.logout}
                            className="btn btn-success mt-5"
                          >
                            Выйти
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      } else {
        return (
          <>
            <div className={makeContainerClasses()}>
              <ScrollTop modalOpened={cx.modalOpened} />
              <HeaderMobile inAdmin={inAdmin} />
              {passwordchange && !inProfile && (
                <div className="alert passchange mb-0 font-weight-bold bg-light-warning text-warning text-center p-5">
                  Администратор установил для вас необходимость смены пароля.
                  <br />
                  <Link
                    to="/profile/"
                    className="btn btn-warning btn-light-primary mt-4"
                  >
                    Сменить пароль
                  </Link>
                </div>
              )}
              <div className="mh100 d-flex flex-column flex-root">
                <div className="d-flex flex-row flex-column-fluid page">
                  <Aside inAdmin={inAdmin} />
                  <div className="d-flex flex-column flex-row-fluid wrapper">
                    <Header />

                    <div
                      className={`content ${
                        fullArea ? "full-area" : ""
                      } d-flex flex-column flex-column-fluid`}
                    >
                      <div ref={subheaderPlaceholderRef}></div>

                      <Switch>
                        <Route
                          path={["/reference/:tabId", "/reference"]}
                          render={({ match, location }) => {
                            return <Reference tabId={match.params.tabId} />;
                          }}
                        />

                        <Route
                          path={[
                            "/staff/:staffid/:mode/:documentid",
                            "/staff/:staffid/:mode",
                            "/staff/:staffid",
                            "/staff/",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Staff
                                staffId={match.params.staffid}
                                documentId={match.params.documentid}
                                mode={match.params.mode || "profile"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route path="/admin">
                          <Admin />
                        </Route>
                        <Route path="/ship-safety">
                          <Docs />
                        </Route>
                        <Route path="/support">
                          <Support />
                        </Route>
                        <Route path="/search">
                          <Search />
                        </Route>

                        <Route
                          path={["/library/:itemId/", "/library/"]}
                          render={({ match }) => {
                            return (
                              <Library
                                title="Библиотека"
                                essence="library"
                                itemId={match.params.itemId}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/techdoc/:itemId/", "/techdoc/"]}
                          render={({ match }) => {
                            return (
                              <Library
                                title="Техническая документация"
                                essence="techdoc"
                                itemId={match.params.itemId}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/emergency_folder/:itemId/",
                            "/emergency_folder/",
                          ]}
                          render={({ match }) => {
                            return (
                              <Library
                                title="Аварийная папка"
                                essence="emergency_folder"
                                itemId={match.params.itemId}
                              />
                            );
                          }}
                        />

                        <Route path="/profile">
                          <Profile />
                        </Route>

                        <Route
                          path={[
                            "/spec/:projectId/:shipId/:itemId",
                            "/spec/:projectId/:shipId",
                            "/spec/:projectId",
                            "/spec/",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Spec
                                projectId={match.params.projectId}
                                shipId={match.params.shipId || cx.api.nullUuid}
                                itemId={match.params.itemId}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/report/:mode/:nodeId/:itemId/:itemMode/:recentItemId",
                            "/report/:mode/:nodeId/:itemId/:itemMode/",
                            "/report/:mode/:nodeId/:itemId",
                            "/report/:mode/:nodeId",
                            "/report/:mode",
                            "/report/",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Report
                                mode={match.params.mode || "default"}
                                nodeId={match.params.nodeId}
                                itemId={match.params.itemId}
                                itemMode={match.params.itemMode || "new"}
                                recentItemId={match.params.recentItemId}
                                location={location}
                              />
                            );
                          }}
                        />

                            );
                          }}
                        />

                        <Route
                          path={[
                            "/model/:categoryId/:modelId/:mode/",
                            "/model/:categoryId/:modelId/",
                            "/model/:categoryId",
                            "/model",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Model
                                mode={match.params.mode || "default"}
                                categoryId={match.params.categoryId || "any"}
                                modelId={match.params.modelId}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/certificate/:shipId/:itemId/",
                            "/certificate/:shipId",
                            "/certificate",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Certificate
                                shipId={match.params.shipId}
                                itemId={match.params.itemId}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/crew/:shipId/", "/crew"]}
                          render={({ match, location }) => {
                            return (
                              <Crew
                                shipId={match.params.shipId}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/element/:shipId/:specId/:elementId/:mode/",
                            "/element/:shipId/:specId/:elementId/",
                            "/element/:shipId/:specId/",
                            "/element/:shipId",
                            "/element",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Element
                                elementId={match.params.elementId}
                                specId={match.params.specId || "any"}
                                shipId={match.params.shipId || "any"}
                                mode={match.params.mode || "default"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/maint/:structureId/:itemId/:mode/",
                            "/maint/:structureId/:itemId/",
                            "/maint/:structureId",
                            "/maint",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Maint
                                itemId={match.params.itemId}
                                structureId={match.params.structureId || "any"}
                                mode={match.params.mode || "default"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/scheme/:itemId/", "/scheme/"]}
                          render={({ match }) => {
                            return (
                              <Scheme
                                itemId={match.params.itemId}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/order/:orderId/", "/order/"]}
                          render={({ match }) => {
                            return (
                              <Order
                                orderId={match.params.orderId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/undertake/:docId/", "/undertake/"]}
                          render={({ match }) => {
                            return (
                              <Undertake
                                docId={match.params.docId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/bunkerorder/:docId/", "/bunkerorder/"]}
                          render={({ match }) => {
                            return (
                              <BunkerOrder
                                docId={match.params.docId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/bunkerupdate/:docId/", "/bunkerupdate/"]}
                          render={({ match }) => {
                            return (
                              <BunkerUpdate
                                docId={match.params.docId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/act_maintenance/:docId/",
                            "/act_maintenance/",
                          ]}
                          render={({ match }) => {
                            return (
                              <ActMaintenance
                                docId={match.params.docId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/repair/:docId/", "/repair/"]}
                          render={({ match }) => {
                            return (
                              <Repair
                                docId={match.params.docId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/fda/:docId/", "/fda/"]}
                          render={({ match }) => {
                            return (
                              <Fda
                                docId={match.params.docId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/request/:requestId/", "/request/"]}
                          render={({ match }) => {
                            return (
                              <Request
                                requestId={match.params.requestId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/timesheet/:documentId/", "/timesheet/"]}
                          render={({ match }) => {
                            return (
                              <Timesheet
                                documentId={match.params.documentId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/delivery/:classcode/:deliveryId/",
                            "/delivery/:classcode/",
                            "/delivery/",
                          ]}
                          render={({ match }) => {
                            return (
                              <Delivery
                                classcode={match.params.classcode}
                                deliveryId={match.params.deliveryId || "add"}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={["/product/:storageId/", "/product/"]}
                          render={({ match }) => {
                            return (
                              <Product storageId={match.params.storageId} />
                            );
                          }}
                        />

                        <Route
                          path={["/chat/:urlParam1/", "/chat/"]}
                          render={({ match }) => {
                            return <Chat urlParam1={match.params.urlParam1} />;
                          }}
                        />
                        <Route
                          path={[
                            "/assistant/:conversationId/",
                            "/assistant/",
                          ]}
                          render={({ match }) => {
                            return (
                              <Assistant
                                conversationId={match.params.conversationId}
                              />
                            );
                          }}
                        />
                        <Route
                          path={["/tasks/:urlParam1/", "/tasks/"]}
                          render={({ match }) => {
                            return <Tasks urlParam1={match.params.urlParam1} />;
                          }}
                        />
                        <Route
                          path={["/notice/:urlParam1/", "/notice/"]}
                          render={({ match }) => {
                            return (
                              <Notice urlParam1={match.params.urlParam1} />
                            );
                          }}
                        />
                        <Route
                          path={["/bunker/:shipId/", "/bunker/"]}
                          render={({ match }) => {
                            return <Bunker shipId={match.params.shipId} />;
                          }}
                        />
                        <Route
                          path={["/ship/:shipId/", "/ship/"]}
                          render={({ match }) => {
                            return <Ship shipId={match.params.shipId} />;
                          }}
                        />
                        <Route
                          path={["/manualchanged/"]}
                          render={({ match }) => {
                            return <ManualChanged />;
                          }}
                        />
                        <Route
                          path={[
                            "/manual/:structure/:document/:mode/:version/",
                            "/manual/:structure/:document/:mode/",
                            "/manual/:structure/:document/",
                            "/manual/:structure",
                            "/manual",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Manual
                                version={match.params.version}
                                mode={match.params.mode}
                                document={match.params.document}
                                structure={match.params.structure}
                                location={location}
                              />
                            );
                          }}
                        />

                        <Route
                          path={[
                            "/tracker/:mode/:itemId/:historyId/",
                            "/tracker/:mode/:itemId/",
                            "/tracker/:mode/",
                            "/tracker/",
                          ]}
                          render={({ match }) => {
                            return (
                              <Tracker
                                mode={match.params.mode || "all"}
                                itemId={match.params.itemId}
                                historyId={match.params.historyId}
                                location={location}
                              />
                            );
                          }}
                        />
                        <Route
                          path={[
                            "/workdoc/:listMode/:structureId/:itemId/",
                            "/workdoc/:listMode/:structureId/",
                            "/workdoc/:listMode",
                            "/workdoc",
                          ]}
                          render={({ match, location }) => {
                            return (
                              <Workdoc
                                listMode={match.params.listMode || "default"}
                                structureId={match.params.structureId || "any"}
                                itemId={match.params.itemId}
                                location={location}
                              />
                            );
                          }}
                        />
                        <Route path="/" exact>
                          <Index />
                        </Route>
                        <Route path="*">
                          <BigError
                            title={cx.t("error.notFound.title")}
                            message={cx.t("error.notFound.message")}
                          />
                        </Route>
                      </Switch>
                    </div>
                  </div>

                  <Subheader cx={cx} placeholderRef={subheaderPlaceholderRef} />
                </div>
              </div>
            </div>
            <UserMenu />
          </>
        );
      }
    } else {
      if (!cx.user.pending) {
        document.location.replace(window.appConfig.authUrl);
      }
      return <Pending />;
    }
  }
}

export default Layout;
